import { QueryKeys } from "../../utils/queryKeys";

export const moduleKeys = {
  all: [QueryKeys.MODULE_TYPE_LIST],

  getModuleKeys: (args) => {
    const { courseId, languageId } = args;

    return [...moduleKeys.all, courseId, languageId];
  },
};
